import React from 'react';
import { RiArrowRightUpLine } from 'react-icons/ri';
import { useInView } from 'react-intersection-observer';
import Item from './components/Item';
import { DoWellBackground, DoWellContainer, GridContainer, SeeOpenRoles } from './styled';
import { ITEMS } from './consts';

const DoWell = () => {
  const goToOpenRoles = () => {
    window.open('https://safetywing.pinpointhq.com', '_blank');
  };

  const { ref, inView } = useInView({
    threshold: 0.2
  });

  const containerVariants = {
    initial: {},
    animate: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const buttonVariants = {
    show: {
      y: -25,
      opacity: 1,
      transition: {
        duration: 1.5
      }
    }
  };

  return (
    <DoWellBackground>
      <DoWellContainer ref={ref}>
        <h1>How to do well at SafetyWing</h1>

        <GridContainer
          variants={containerVariants}
          animate={inView && 'animate'}
          initial="initial"
        >
          {ITEMS.map((item) => (
            <Item
              key={item.id}
              name={item.name}
              description={item.description}
              background={item.background}
            />
          ))}
        </GridContainer>

        <SeeOpenRoles
          initial={{ y: 0, opacity: 0 }}
          variants={buttonVariants}
          animate={inView && 'show'}
          onClick={goToOpenRoles}
        >
          <span>See open roles</span>
          <RiArrowRightUpLine size={22} />
        </SeeOpenRoles>
      </DoWellContainer>
    </DoWellBackground>
  );
};

export default DoWell;
